module.exports = __webpack_public_path__ + "static/media/drag_handle-24px.10e17973.svg";